// extracted by mini-css-extract-plugin
export var active = "_7z-1";
export var activeSubdued = "_7z-2";
export var compact = "_7z-3";
export var fill = "_7z-6";
export var pulse = "_7z-4";
export var settingHighlightPulse = "_7z-5";
export var wrapper = "_7z-0";